
export default {
  state: {
    ListChecked: [],
    treeChecked: []
  },
  mutations: {
    setListChecked(state, value) {
      state.ListChecked = value;
    },

    setTreeChecked(state, value) {
      state.treeChecked = value;
    },

    deleteListed(state, id) {
      const index = state.ListChecked.findIndex(item => {
        const ObjItem = JSON.parse(item)
        return ObjItem.id == id
      })
      if (index >= 0) {
        //引用类型  state List删除了   页面中的list也删除了
        state.ListChecked.splice(index, 1)
      }
    },

    deleteTree(state, id) {
      const index = state.treeChecked.findIndex(item => {
        return item.id == id
      })
      if (index >= 0) {
        // 需要手动 去setTreeKey
        state.treeChecked.splice(index, 1)
      }
    },
    
    //重置
    industryReset(state) {
      //重置的 引用发生了变化,所以一定要在文件内监听  ,不能靠引用类型的"便利"直接改变
      state.ListChecked = [];
      state.treeChecked = [];
    }
  }
}